export default "__VITE_ASSET__DLEfjYMg__"